import React from 'react';
import { keyBy } from 'lodash';

import { useClaim } from '~/components/ClaimContainer';
import Chip from '~/components/core/Atomic/Chip/Chip';
import Text from '~/components/core/TextComponents/Text';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';
import Divider from '~/components/ui/atoms/Divider';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';
import { getExposuresLabels } from '~/Utils';

interface ExposuresPropsType {
  contact: ContactFullModel;
}

const Exposures: React.FC<ExposuresPropsType> = ({ contact }) => {
  const { claim } = useClaim();

  if (!claim) {
    return null;
  }

  const exposureLabels = getExposuresLabels(claim);
  const exposureLabelsDict = keyBy(exposureLabels, 'id');

  return (
    <>
      <Divider className="my-12" />
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
        Exposures
      </Text>
      {(contact.exposure_ids || []).map((exposure_id) => (
        <>
          <Chip
            key={exposure_id}
            size="small"
            className="my-4 mr-4"
            label={
              <OverflowTextWithToolTip maxWidth="130px">
                {exposureLabelsDict[exposure_id].label}
              </OverflowTextWithToolTip>
            }
          />
        </>
      ))}
    </>
  );
};

export default Exposures;
